export function setNativeValue(
  element: HTMLElement,
  value: HTMLElement['nodeValue']
) {
  const valueSetter = Object.getOwnPropertyDescriptor(element, 'value')?.set
  const prototype = Object.getPrototypeOf(element)
  const prototypeValueSetter = Object.getOwnPropertyDescriptor(
    prototype,
    'value'
  )?.set

  if (
    valueSetter &&
    prototypeValueSetter &&
    valueSetter !== prototypeValueSetter
  ) {
    prototypeValueSetter.call(element, value)
  } else if (valueSetter) {
    valueSetter.call(element, value)
  }
}
